(function () {
  'use strict';

  window.kasPushReady = true;

  var config = window.kasPushConfig;
  if (!config || !config.enabled) {
    return;
  }

  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) {
    console.warn('[kas-push] Browser does not support web push on this page.');
    return;
  }

  var STORAGE_DISMISS = 'kas_push_dismissed_until';
  var STORAGE_VISITOR = 'kas_push_visitor_id';
  var STORAGE_SUBSCRIBED = 'kas_push_subscribed';
  var STORAGE_MB_SYNCED = 'kas_push_mb_synced';
  var STORAGE_SW_PATH = 'kas_push_sw_path';
  var MAGICBELL_API = 'https://api.magicbell.com/v2';

  function debug() {
    if (config.debug) {
      console.log.apply(console, ['[kas-push]'].concat(Array.prototype.slice.call(arguments)));
    }
  }

  function logError(message, err) {
    console.error('[kas-push]', message, err || '');
  }

  function showForegroundPushToast(payload) {
    if (!payload) {
      return;
    }

    var existing = document.getElementById('kas-push-toast');
    if (existing) {
      existing.parentNode.removeChild(existing);
    }

    var title = payload.title || 'KAS Australia';
    var body = payload.content || payload.body || '';
    var url = payload.action_url || '';

    var toastH = config.toastPositionHorizontal || 'right';
    var toastV = config.toastPositionVertical || 'top';
    var toast = document.createElement('div');
    toast.id = 'kas-push-toast';
    toast.className =
      'kas-push-toast kas-push-toast--h-' +
      toastH +
      ' kas-push-toast--v-' +
      toastV +
      ' is-visible';
    toast.setAttribute('role', 'alert');

    var titleEl = document.createElement('p');
    titleEl.className = 'kas-push-toast__title';
    titleEl.textContent = title;
    toast.appendChild(titleEl);

    if (body) {
      var bodyEl = document.createElement('p');
      bodyEl.className = 'kas-push-toast__body';
      bodyEl.textContent = body;
      toast.appendChild(bodyEl);
    }

    if (url) {
      var link = document.createElement('a');
      link.className = 'kas-push-toast__link';
      link.href = url;
      link.textContent = config.toastViewLabel || 'View';
      link.rel = 'noopener';
      toast.appendChild(link);
    }

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'kas-push-toast__close';
    closeBtn.setAttribute('aria-label', 'Dismiss');
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 250);
    });
    toast.appendChild(closeBtn);

    document.body.appendChild(toast);

    window.setTimeout(function () {
      if (!toast.parentNode) {
        return;
      }
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 250);
    }, Math.max(3, parseInt(config.toastDurationSeconds, 10) || 10) * 1000);
  }

  navigator.serviceWorker.addEventListener('message', function (event) {
    if (!event.data || event.data.type !== 'KAS_PUSH_RECEIVED') {
      return;
    }
    showForegroundPushToast(event.data.payload);
    if (config.debug) {
      console.log(
        '[kas-push] Foreground toast shown. Chrome usually hides the OS banner while this tab is focused — minimize Chrome or open another tab to see the system notification.'
      );
    }
  });

  function getVisitorId() {
    var id = localStorage.getItem(STORAGE_VISITOR);
    if (!id) {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        id = 'kas_' + window.crypto.randomUUID().replace(/-/g, '');
      } else {
        id = 'kas_' + String(Date.now()) + Math.random().toString(36).slice(2, 10);
      }
      localStorage.setItem(STORAGE_VISITOR, id);
    }
    return id;
  }

  function isDismissed() {
    var until = localStorage.getItem(STORAGE_DISMISS);
    return until && Date.now() < parseInt(until, 10);
  }

  function dismissBanner(days) {
    var duration = typeof days === 'number' ? days : 30;
    localStorage.setItem(STORAGE_DISMISS, String(Date.now() + duration * 86400000));
  }

  function markSubscribed() {
    localStorage.setItem(STORAGE_SUBSCRIBED, 'true');
  }

  function clearSubscribedMark() {
    localStorage.removeItem(STORAGE_SUBSCRIBED);
  }

  function isMarkedSubscribed() {
    return localStorage.getItem(STORAGE_SUBSCRIBED) === 'true';
  }

  function markMbSynced() {
    localStorage.setItem(STORAGE_MB_SYNCED, 'true');
  }

  function clearMbSyncedMark() {
    localStorage.removeItem(STORAGE_MB_SYNCED);
  }

  function isMbSynced() {
    return localStorage.getItem(STORAGE_MB_SYNCED) === 'true';
  }

  function unregisterAllPushSubscriptions() {
    if (!('serviceWorker' in navigator)) {
      return Promise.resolve();
    }
    return navigator.serviceWorker.getRegistrations().then(function (registrations) {
      return Promise.all(
        registrations.map(function (reg) {
          return reg.pushManager.getSubscription().then(function (sub) {
            if (sub) {
              return sub.unsubscribe();
            }
          });
        })
      );
    });
  }

  function checkServiceWorkerPathChange() {
    var current = config.serviceWorkerPath || '';
    var stored = localStorage.getItem(STORAGE_SW_PATH);
    if (stored && stored !== current) {
      debug('Service worker path changed — clearing push subscription');
      clearSubscribedMark();
      clearMbSyncedMark();
      return unregisterAllPushSubscriptions().then(function () {
        localStorage.setItem(STORAGE_SW_PATH, current);
      });
    }
    if (current) {
      localStorage.setItem(STORAGE_SW_PATH, current);
    }
    return Promise.resolve();
  }

  function findExistingPushSubscription() {
    if (!('serviceWorker' in navigator)) {
      return Promise.resolve(null);
    }
    return navigator.serviceWorker.getRegistrations().then(function (registrations) {
      if (!registrations.length) {
        return null;
      }
      var path = config.serviceWorkerPath || '';
      var registration = null;
      for (var i = 0; i < registrations.length; i++) {
        var reg = registrations[i];
        if (
          path &&
          reg.active &&
          reg.active.scriptURL &&
          reg.active.scriptURL.indexOf('kas-push-sw') !== -1
        ) {
          registration = reg;
          break;
        }
      }
      if (!registration) {
        registration = registrations[registrations.length - 1];
      }
      return registration.pushManager.getSubscription();
    }).catch(function () {
      return null;
    });
  }

  function resolveOptInState() {
    return findExistingPushSubscription().then(function (existingSub) {
      var permission = Notification.permission;
      var wasMarkedSubscribed = isMarkedSubscribed();
      var wasMbSynced = isMbSynced();

      if (permission !== 'granted' && (wasMarkedSubscribed || wasMbSynced)) {
        clearSubscribedMark();
        clearMbSyncedMark();
        debug('Cleared subscribed flag (notification permission revoked)');
      }

      if (permission === 'granted' && (existingSub || wasMarkedSubscribed)) {
        var needsSync = !!existingSub && !wasMbSynced;
        if (existingSub) {
          markSubscribed();
        }
        return {
          showBanner: false,
          syncMagicBell: needsSync,
        };
      }

      if (wasMarkedSubscribed && !existingSub) {
        clearSubscribedMark();
        clearMbSyncedMark();
        debug('Cleared stale subscribed flag (no push subscription in browser)');
      }

      return { showBanner: true, syncMagicBell: false };
    });
  }

  function shouldShowOnTemplate() {
    var allowed = config.templates || 'all';
    if (allowed === 'all' || allowed === '') {
      return true;
    }
    var current = config.templateName || '';
    var list = allowed.split(',').map(function (item) {
      return item.trim();
    }).filter(Boolean);
    return list.indexOf(current) !== -1;
  }

  function setStatus(el, message, isError) {
    if (!el) return;
    el.textContent = message || '';
    el.classList.toggle('is-error', !!isError);
    el.hidden = !message;
  }

  function buildJwtUrl() {
    var params = new URLSearchParams();
    if (window.kasShopifyCustomerLoggedIn && window.customer && window.customer.id) {
      params.set('customer_id', String(window.customer.id));
      if (window.customer.email) {
        params.set('email', window.customer.email);
      }
    } else {
      params.set('visitor_id', getVisitorId());
    }
    return config.jwtEndpoint + '?' + params.toString();
  }

  function urlBase64ToUint8Array(base64String) {
    var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  function fetchUserJwt() {
    var url = buildJwtUrl();
    debug('Fetching JWT:', url);
    return fetch(url, { method: 'GET', credentials: 'omit' }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (body) {
          throw new Error(body.message || body.error || 'Could not prepare notifications');
        });
      }
      return response.json();
    }).then(function (data) {
      if (!data || !data.token) {
        throw new Error('Missing MagicBell token');
      }
      return data.token;
    });
  }

  function magicBellFetch(userToken, path, options) {
    var opts = options || {};
    opts.headers = Object.assign(
      {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + userToken,
      },
      opts.headers || {}
    );
    return fetch(MAGICBELL_API + path, opts).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) {
          var msg =
            (body && body.errors && body.errors[0] && body.errors[0].message) ||
            (body && body.error) ||
            'MagicBell API error (' + response.status + ')';
          throw new Error(msg);
        }
        return body;
      });
    });
  }

  function getServiceWorkerRegisterOptions() {
    var path = config.serviceWorkerPath;
    var options;
    var scope = config.serviceWorkerScope;
    if (scope && String(scope).trim() !== '') {
      options = { scope: String(scope).trim() };
    } else if (path === '/sw.js' || (path && /\/sw\.js(\?|$)/.test(path) && path.indexOf('/cdn/') === -1)) {
      options = { scope: '/' };
    }
    return { path: path, options: options };
  }

  function pushConfigToServiceWorker(registration) {
    if (!registration || !registration.active || !config.notificationIcon) {
      return;
    }
    registration.active.postMessage({
      type: 'KAS_PUSH_CONFIG',
      icon: config.notificationIcon,
    });
  }

  function registerServiceWorker() {
    var reg = getServiceWorkerRegisterOptions();
    if (!reg.path) {
      return Promise.reject(new Error('Service worker path is not configured'));
    }
    return navigator.serviceWorker.register(reg.path, reg.options).then(function (registration) {
      console.log('[kas-push] Service worker registered', {
        script: reg.path,
        scope: registration.scope,
        active: !!registration.active,
      });
      pushConfigToServiceWorker(registration);
      return registration;
    });
  }

  function testOsNotification() {
    if (Notification.permission !== 'granted') {
      console.warn('[kas-push] Grant notification permission first (Enable alerts).');
      return Promise.resolve();
    }
    return navigator.serviceWorker.ready
      .then(function (registration) {
        pushConfigToServiceWorker(registration);
        return registration.showNotification('KAS test notification', {
          body: 'If you see this, your browser and OS allow notifications. MagicBell push uses the service worker.',
          icon: config.notificationIcon || undefined,
          tag: 'kas-push-debug-test',
          renotify: true,
        });
      })
      .then(function () {
        console.log('[kas-push] testOsNotification: check your OS notification center.');
      })
      .catch(function (err) {
        logError('testOsNotification failed', err);
      });
  }

  function logPushDiagnostics(context) {
    return findExistingPushSubscription()
      .then(function (subscription) {
        return navigator.serviceWorker.getRegistrations().then(function (registrations) {
          console.log('[kas-push] Diagnostics (' + (context || 'check') + ')', {
            permission: Notification.permission,
            serviceWorkerPath: config.serviceWorkerPath,
            serviceWorkerScope: config.serviceWorkerScope || '(default)',
            registrations: registrations.map(function (r) {
              return {
                scope: r.scope,
                active: !!(r.active && r.active.scriptURL),
                scriptURL: r.active ? r.active.scriptURL : null,
              };
            }),
            pushSubscription: subscription
              ? { endpoint: subscription.endpoint.substring(0, 72) + '…' }
              : null,
            markedSubscribed: isMarkedSubscribed(),
            mbSynced: isMbSynced(),
            hint:
              'MagicBell delivery.sent 200 means the push reached Google/Mozilla. If you see nothing, check OS notification settings and use DevTools → Application → Service Workers → Push to test.',
          });
        });
      })
      .catch(function (err) {
        logError('Diagnostics failed', err);
      });
  }

  function waitForActiveRegistration(registration, timeoutMs) {
    if (registration.active) {
      return Promise.resolve(registration);
    }

    timeoutMs = timeoutMs || 12000;

    return new Promise(function (resolve, reject) {
      var settled = false;

      function done(reg) {
        if (settled) {
          return;
        }
        settled = true;
        window.clearTimeout(timer);
        resolve(reg);
      }

      var timer = window.setTimeout(function () {
        debug('Waiting for service worker.ready (timeout fallback)');
        navigator.serviceWorker.ready.then(done).catch(reject);
      }, timeoutMs);

      var sw = registration.installing || registration.waiting;
      if (sw) {
        sw.addEventListener('statechange', function () {
          debug('Service worker state:', sw.state);
          if (sw.state === 'activated') {
            done(registration);
          }
        });
      } else {
        navigator.serviceWorker.ready.then(done).catch(reject);
      }
    });
  }

  function getReadyRegistration() {
    return registerServiceWorker().then(waitForActiveRegistration);
  }

  function isServiceWorkerReadyError(err) {
    var msg = err && err.message ? err.message : String(err);
    return /no active Service Worker|Subscription failed/i.test(msg);
  }

  function createPushSubscription(registration, publicKey) {
    return registration.pushManager.getSubscription().then(function (existing) {
      if (existing) {
        debug('Reusing existing push subscription');
        return existing;
      }
      return registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    });
  }

  function subscribePush(registration, publicKey, attempt) {
    attempt = attempt || 0;
    return waitForActiveRegistration(registration)
      .then(function (reg) {
        return createPushSubscription(reg, publicKey);
      })
      .catch(function (err) {
        if (attempt < 2 && isServiceWorkerReadyError(err)) {
          debug('Retrying subscribe after service worker activation', attempt + 1);
          return navigator.serviceWorker.ready.then(function (readyReg) {
            return subscribePush(readyReg, publicKey, attempt + 1);
          });
        }
        throw err;
      });
  }

  function preloadServiceWorker() {
    if (!config.serviceWorkerPath) {
      return;
    }
    getReadyRegistration()
      .then(function (registration) {
        pushConfigToServiceWorker(registration);
        debug('Service worker preloaded');
      })
      .catch(function (err) {
        debug('Service worker preload failed', err);
      });
  }

  function subscribeAndSaveToken(userToken) {
    return magicBellFetch(userToken, '/integrations/web_push/installations/start', {
      method: 'POST',
    }).then(function (install) {
      if (!install || !install.public_key) {
        throw new Error('MagicBell Web Push is not configured in your dashboard');
      }
      debug('VAPID public key received');
      return getReadyRegistration()
        .then(function (registration) {
          return subscribePush(registration, install.public_key);
        })
        .then(function (subscription) {
          var json = subscription.toJSON();
          return magicBellFetch(userToken, '/channels/web_push/tokens', {
            method: 'PUT',
            body: JSON.stringify({
              endpoint: json.endpoint,
              keys: {
                p256dh: json.keys.p256dh,
                auth: json.keys.auth,
              },
            }),
          }).then(function () {
            markMbSynced();
            if (config.serviceWorkerPath) {
              localStorage.setItem(STORAGE_SW_PATH, config.serviceWorkerPath);
            }
            console.log('[kas-push] Push subscription saved to MagicBell');
            logPushDiagnostics('after-subscribe');
            return subscription;
          });
        });
    });
  }

  function runSubscribe(userToken) {
    return subscribeAndSaveToken(userToken).then(function () {
      markSubscribed();
      markMbSynced();
    });
  }

  function runSubscribeFlow(statusEl, enableBtn, hideBanner, options) {
    options = options || {};
    setStatus(statusEl, config.loadingLabel || 'Setting up notifications…', false);
    if (enableBtn && !options.keepButtonEnabled) {
      enableBtn.disabled = true;
      enableBtn.setAttribute('aria-busy', 'true');
    }

    var permissionPromise = Promise.resolve(Notification.permission);
    if (Notification.permission === 'default') {
      permissionPromise = Notification.requestPermission();
    }

    return permissionPromise
      .then(function (permission) {
        if (permission === 'denied') {
          throw new Error(
            config.deniedMessage || 'Notifications are blocked in your browser settings.'
          );
        }
        if (permission !== 'granted') {
          throw new Error('Notification permission was not granted.');
        }
        return fetchUserJwt();
      })
      .then(runSubscribe)
        .then(function () {
          setStatus(statusEl, config.successMessage || 'You are subscribed to sale alerts.', false);
          if (enableBtn) {
            enableBtn.disabled = false;
            enableBtn.removeAttribute('aria-busy');
          }
          if (hideBanner) {
            window.setTimeout(hideBanner, 2500);
          }
        })
      .catch(function (error) {
        logError('Subscribe failed', error);
        var message = error.message || 'Something went wrong.';
        if (isServiceWorkerReadyError(error)) {
          message =
            'Notifications are still activating. Wait a moment and click Enable alerts again.';
        } else if (/service worker|scope|security/i.test(message)) {
          message +=
            ' If this keeps happening, a root /sw.js may be required for Shopify — check the browser console.';
        }
        setStatus(statusEl, message, true);
        if (enableBtn) {
          enableBtn.disabled = false;
          enableBtn.removeAttribute('aria-busy');
        }
        throw error;
      });
  }

  var isMobileViewport = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

  function init() {
    // Mobile: don't interrupt product and cart pages (sticky Add to Cart lives there)
    if (!config.preview && isMobileViewport && (config.templateName === 'product' || config.templateName === 'cart')) {
      debug('Banner skipped on mobile product/cart');
      return;
    }
    debug('init', { permission: Notification.permission, subscribed: localStorage.getItem(STORAGE_SUBSCRIBED) });

    if (!config.preview && (isDismissed() || !shouldShowOnTemplate())) {
      debug('Banner skipped (dismissed or template filter)');
      return;
    }

    var banner = document.getElementById('kas-push-optin');
    if (!banner) {
      console.warn('[kas-push] Banner markup not found — enable push in Theme → Header.');
      return;
    }

    var enableBtn = banner.querySelector('[data-kas-push-enable]');
    var dismissBtn = banner.querySelector('[data-kas-push-dismiss]');
    var statusEl = banner.querySelector('[data-kas-push-status]');
    var delayMs = Math.max(0, parseInt(config.delaySeconds, 10) || 30) * 1000;
    var engaged = false;
    var allowBannerDisplay = false;
    var showTimerId = null;

    function showBanner() {
      if (!allowBannerDisplay || (!config.preview && isDismissed())) {
        return;
      }
      banner.classList.remove('kas-push-optin--subscribed');
      banner.classList.add('is-visible');
      banner.setAttribute('aria-hidden', 'false');
    }

    function hideBanner() {
      banner.classList.remove('is-visible');
      banner.classList.add('kas-push-optin--subscribed');
      banner.setAttribute('aria-hidden', 'true');
    }

    function cancelScheduledBanner() {
      if (showTimerId !== null) {
        window.clearTimeout(showTimerId);
        showTimerId = null;
      }
    }

    function scheduleBannerShow() {
      // Mobile: only show after the shopper has scrolled (engaged), never on a timer
      if (isMobileViewport && !config.preview) {
        return;
      }
      if (!allowBannerDisplay || showTimerId !== null) {
        return;
      }
      showTimerId = window.setTimeout(function () {
        showTimerId = null;
        showBanner();
      }, delayMs);
    }

    function suppressBannerPermanently() {
      allowBannerDisplay = false;
      cancelScheduledBanner();
      hideBanner();
    }

    hideBanner();

    window.addEventListener(
      'scroll',
      function onScroll() {
        if (!allowBannerDisplay) {
          return;
        }
        if (window.scrollY > 240) {
          engaged = true;
          showBanner();
          window.removeEventListener('scroll', onScroll);
        }
      },
      { passive: true }
    );

    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        dismissBanner(config.dismissDays || 30);
        hideBanner();
      });
    }

    if (!enableBtn) {
      return;
    }

    var activeSubscribePromise = null;

    function startSubscribe(source) {
      console.log('[kas-push] Starting subscribe (' + (source || 'click') + ')');

      if (activeSubscribePromise) {
        return activeSubscribePromise;
      }

      activeSubscribePromise = runSubscribeFlow(statusEl, enableBtn, hideBanner, {
        keepButtonEnabled: source === 'background',
      })
        .then(function () {
          suppressBannerPermanently();
        })
        .catch(function () {
          /* errors handled in runSubscribeFlow */
        })
        .then(function () {
          activeSubscribePromise = null;
        });

      return activeSubscribePromise;
    }

    checkServiceWorkerPathChange()
      .then(function () {
        preloadServiceWorker();
      })
      .catch(function (err) {
        logError('Service worker path check failed', err);
        preloadServiceWorker();
      });

    banner.addEventListener('click', function (event) {
      var clickedEnable = event.target.closest('[data-kas-push-enable]');
      if (!clickedEnable) {
        return;
      }

      event.preventDefault();
      console.log('[kas-push] Enable alerts clicked', {
        permission: Notification.permission,
        disabled: enableBtn.disabled,
        inFlight: !!activeSubscribePromise,
      });

      if (enableBtn.disabled && !activeSubscribePromise) {
        enableBtn.disabled = false;
        enableBtn.removeAttribute('aria-busy');
      }

      startSubscribe('click');
    });

    if (config.debug) {
      logPushDiagnostics('page-load');
      window.kasPushTestNotification = testOsNotification;
      console.log(
        '[kas-push] Debug: run kasPushTestNotification() to test OS notifications. Debug does not force the opt-in banner — use ?kas_push_preview=1'
      );
    }

    if (config.preview) {
      console.log('[kas-push] Preview mode: forcing opt-in banner (ignores dismiss/subscribed delay)');
      allowBannerDisplay = true;
      showBanner();
      return;
    }

    resolveOptInState().then(function (state) {
      if (!state.showBanner) {
        debug('Already subscribed — banner suppressed');
        suppressBannerPermanently();
        if (state.syncMagicBell) {
          startSubscribe('background').catch(function (err) {
            logError('Background MagicBell sync failed', err);
          });
        }
        return;
      }

      allowBannerDisplay = true;
      scheduleBannerShow();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
